import { FormattedMessage } from 'react-intl';
import { Box, Flex } from '@theme-ui/components';

import useLocaleWithFallback from '@app/hooks/useLocaleWithFallback';
import type * as Types from '@__graphql__/types';

import Icon from '../ProductUpgradeMessage/icons';
import translations from '../ProductUpgradeMessage/ProductUpgradeMessage.messages';

const RequiredProductsWarning = ({
  messages,
}: {
  messages?: Types.Maybe<Types.Required_Base_Products_Translations>[] | null;
}) => {
  const { findTranslationByKeyWithFallback } = useLocaleWithFallback();

  const requiredBaseProducts = findTranslationByKeyWithFallback({
    translations: messages,
    key: 'required_base_products',
  });

  return (
    <Flex data-testid="required-products-message">
      <Box mr={2}>
        <Icon width={25} type="exclamation-mark-yellow" />
      </Box>
      <Box sx={{ flex: 1 }} mb={4}>
        <Box
          sx={{
            fontWeight: 'bold',
            // remove margin from p tag when injected from the CMS
            '& > p': { m: 0 },
          }}
          mb={1}
          dangerouslySetInnerHTML={{
            __html: requiredBaseProducts,
          }}
        />

        <div>
          <FormattedMessage {...translations.ownershipWarning} />
        </div>
      </Box>
    </Flex>
  );
};

export default RequiredProductsWarning;
